import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import IResponse = ZoneIQCalibration.IResponse;
import { CalibrationBonusValue } from '../../models/calibrations/calibration-bonus-value.model';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-bonus';

@Injectable({
    providedIn: 'root'
})
export class CalibrationBonusService {
    constructor(private readonly http: HttpClient) {}

    saveChanges(calibrationBonusData: CalibrationBonusValue[]) {
        if (!_.get(calibrationBonusData, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(API, calibrationBonusData, { headers, params });
    }
}
